<template>
  <Panel>
    <header class="jw-header" slot="panel">
      <a-row :gutter="[84,8]">
        <a-col :lg="{ span: 4 }" :sm="{span: 4}">
          <img class="logo" src="@/assets/img/logo.png" @click="jumpHome" alt="">
        </a-col>
        <a-col :lg="{ span: 20 }" :sm="{span: 18}" class="text-right">
          <!-- <a-button icon="menu" class="mobile-menu" @click="showMenu"></a-button> -->
          <MulLanguage :isEnglish="isEnglish"></MulLanguage>
          <Navigation ref="navigation">
            <!-- <li class="btn-try-buy right" slot="menu" v-if="!isEnglish"> -->
              <!-- <SkewButton class="line-normal" @click="handleJump" :text="$root.language.trybuy"></SkewButton> -->
            <!-- </li> -->
          </Navigation>
        </a-col>
      </a-row>
    </header>
  </Panel>
</template>

<script>
import Panel from '@/components/panel'
import MulLanguage from './mul-language'
import Navigation from './navigation'
// import SkewButton from '@/components/button-skew'
export default {
  components: {
    Panel,
    MulLanguage,
    Navigation
    // SkewButton
  },

  computed: {
    isEnglish () {
      return localStorage.getItem('jw-locale') === 'en-US'
    }
  },

  methods: {
    jumpHome () {
      this.$router.push({
        path: '/'
      })
    },

    handleJump () {
      if (this.$route.path !== '/trybuy') {
        this.$router.push({
          path: '/trybuy'
        })
      }
    },

    showMenu () {
      console.log('this.$refs.navigation.$el')
    }
  }
}

</script>

<style scoped>
  .jw-header {
    padding-top: 5px;
  }

  .logo {
    width: 180px;
    height: 55px;
    margin-top: 15px;
    cursor: pointer;
  }

  .line-normal{
    font-weight: bold;
    font-size: 17px;
  }

  .btn-try-buy {
    margin: 10px 10px 0 10px;
  }

</style>
